import { Component, OnInit } from '@angular/core';
import ApexCharts from 'apexcharts';
import { ChartService } from 'src/app/services/chart.service';
import { ResponseObject } from 'src/app/models/response-object.model';
import { HttpErrorResponse } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { MathUtil } from 'src/app/common/util';

@Component({
  selector: 'app-accounting-chart-balance',
  templateUrl: './accounting-chart-balance.component.html',
  styleUrls: ['./accounting-chart-balance.component.scss']
})
export class AccountingChartBalanceComponent implements OnInit {
  year = null;
  years = [];
  accountingBalanceData = null;
  name = "";
  show = false;
  constructor(
    private chartService: ChartService,
    private toastService: ToastrService
  ) {
    this.year = new Date().getFullYear();
    var origin = 2022;
    for (let index = origin; index <= (this.year + 3); index++) {
      this.years.push(index);
    }
  }
  chartBalance = null;

  ngOnInit() {
    this.updateChart();
  }

  updateChart() {
    this.show = false;
    if (document.getElementById("accounting-general-balance").innerHTML !== "") {
      document.getElementById("accounting-general-balance").innerHTML = "";
    }
    this.chartService.getAccountingBalanceChart(this.year).subscribe({
      next: (response: ResponseObject) => {
        var data = response.data;
        this.accountingBalanceData = data;
        const options = {
          colors: ['#78A2CC', '#ff6961'],
          chart: {
            height: 350,
            type: 'bar',
            events: {
              dataPointSelection: (event, chartContext, config) => {
                // Evento de clic en un punto de datos
                this.show = true;
                setTimeout(() => {
                  document.getElementById("accounting-general-balance").innerHTML = "";
                  this.chartBalance.render();
                  this.showingColumn(config.seriesIndex);
                }, 100);
              },
            }
          },
          plotOptions: {
            bar: {
              horizontal: false,
              columnWidth: '55%',
              endingShape: 'rounded'
            },
          },
          dataLabels: {
            enabled: false
          },
          stroke: {
            show: true,
            width: 2,
            colors: ['transparent']
          },
          series: [{
            name: 'Activo: ',
            data: [{
              x: `${this.year}`,
              y: data.totalActivo,
              title: 'Activo',
              value: data.totalActivo,
              color: '#78A2CC'
            }]
          }, {
            name: 'Pasivo: ',
            data: [{
              x: `${this.year}`,
              y: data.totalPasivoCapital,
              title: 'Pasivo',
              value: data.totalPasivoCapital,
              color: '#ff6961'
            }]
          }],
          xaxis: {
            categories: [`${this.year}`]
          },
          yaxis: {
            title: {
              text: ''
            },
            labels: {
              formatter: function (val) {
                return MathUtil.formatCurrency(val);
              }
            }
          },
          fill: {
            opacity: 1

          },
          tooltip: {
            custom: function ({ series, seriesIndex, dataPointIndex, w }) {
              var data = w.globals.initialSeries[seriesIndex].data[dataPointIndex];

              return '<div style="padding:0.5em; margin:0;"><p class="h6">' + data.title + '<span style="color: ' + data.color + ';">⬤</span></p>' +
                '<p class="h4" style="color: ' + data.color + ';"><b>Q ' + data.value + '</b></p></div>';
            }
          },
          legend: {
            offsetY: 0,
            formatter: function (seriesName, opts) {
              return '<span>' + seriesName + '</span>' +
                '<span style="color: ' + opts.w.config.colors[opts.seriesIndex] + ';"><b>Q ' + opts.w.globals.series[opts.seriesIndex] + '</b></span>';
            }
          }
        }
        const chart = new ApexCharts(
          document.querySelector("#accounting-general-balance"),
          options
        );
        this.chartBalance = chart;
        this.chartBalance.render();
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error(error.error.message);
      }
    });
  }

  showingColumn(column) {
    document.getElementById('accounting-general-detail').innerHTML = "";
    var tempColumn = [];
    var data = [];
    if (column == 0) {
      this.name = "Detalle de Activos"
      tempColumn = this.accountingBalanceData.activoCorriente;

    } else {
      this.name = "Detalle de Pasivos"
      tempColumn = this.accountingBalanceData.pasivoCorriente;
      console.log(this.accountingBalanceData.utilidades);

      this.accountingBalanceData.utilidades.forEach((c) => {
        data.push({ name: c.name, data: [c.balance] });
      })
    }
    console.log(tempColumn);

    tempColumn.forEach((c) => {
      data.push({ name: c.name, data: [c.balance] });
    })

    console.log(data);


    const options = {
      title: {
        text: this.name
      },
      chart: {
        height: 360,
        type: 'bar',
      },
      plotOptions: {
        bar: {
          colors: {
            ranges: [
              {
                from: -100,
                to: -46,
                color: '#F15B46'
              }, {
                from: -45,
                to: 0,
                color: '#FEB019'
              }
            ]
          },
          columnWidth: '80%',
        }
      },
      dataLabels: {
        enabled: false,
      },
      series: data,
      yaxis: {
        title: {
          text: '',
        },
        labels: {
          formatter: function (val) {
            return MathUtil.formatCurrency(val);
          }
        }
      },
      xaxis: {
        // TODO: uncomment below and fix the error
        //type: 'datetime',
        categories: [
          `${this.year}`
        ],
        labels: {
          rotate: -90
        }
      },
      tooltip: {},
      legend: {
        formatter: function (seriesName, opts) {
          return '<span>' + seriesName + '</span>' +
            '<span><b> Q' + opts.w.globals.series[opts.seriesIndex] + '</b></span>';
        }
      }
    }
    const chart = new ApexCharts(
      document.querySelector("#accounting-general-detail"),
      options
    );
    chart.render();
  }
}
